const alphabetically = (a: string, b: string) => a.localeCompare(b);

export const sort = {
  alphabetically,
};
